import { render, staticRenderFns } from "./InspiniaGridItem.vue?vue&type=template&id=a9531be4&"
import script from "./InspiniaGridItem.vue?vue&type=script&lang=ts&"
export * from "./InspiniaGridItem.vue?vue&type=script&lang=ts&"
import style0 from "./InspiniaGridItem.vue?vue&type=style&index=0&id=a9531be4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports